import React from "react";
import { VMProvider } from "../../../commons/base/providers/provider";
import WasteAdjustmentViewModel from "./view_models/waste_adjustment_view_model";
import Scaffold from "../../../commons/scaffold/scaffold";
import WasteAdjustmentFilterWidget from "./widgets/waste_adjustment_filter_widget";
import WasteAdjustmentTableWidget from "./widgets/waste_adjustment_table_widget";
import WasteAdjustmentModalWidget from "./widgets/waste_adjustment_modal_widget";

export default class WasteAdjustmentScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new WasteAdjustmentViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showSnackbar={vm.snackBar}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Adjust Form Waste
                            </h1>
                            <WasteAdjustmentFilterWidget />
                            {vm.isShowingModal && (
                                <WasteAdjustmentModalWidget />
                            )}
                            <WasteAdjustmentTableWidget />
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
